import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { DemoContainer } from '@mui/x-date-pickers/internals/demo'
import CalendarIcon from '../svg/CalendarIcon'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import Button from '../../components/button/Button'
import arrowLeftIcon from '../../assets/icons/arrow-left.svg'
import arrowRightIcon from '../../assets/icons/arrow-right.svg'
import './weeklyCalendar.scss'
import dayjs from 'dayjs'

function WeeklyCalendar({ value, setValue, buttonFormat, setArrow, ...props }) {
  const { dataToggle, setDataToggle } = props
  const handleLeftArrowClick = () => {
    if (Object.keys(props).length > 0) {
      setDataToggle(!dataToggle)
    }
    setValue((prevValue) => prevValue.subtract(1, buttonFormat))
    if (setArrow) {
      setArrow('left')
    }
  }

  const handleRightArrowClick = () => {
    if (Object.keys(props).length > 0) {
      setDataToggle(!dataToggle)
    }
    setValue((prevValue) => prevValue.add(1, buttonFormat))
    if (setArrow) {
      setArrow('right')
    }
  }
  return (
    <div className='weekly-calendar flex justify-center align-center sm-timetable-calender'>
      <Button className={'calendar-arrow'} onClick={handleLeftArrowClick}>
        <img src={arrowLeftIcon} alt='Previous Day' />
      </Button>
      <div className='mui-calendar'>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DemoContainer components={['DatePicker']}>
            <DatePicker
              className='mui-calendar-date-picker'
              value={dayjs(value)}
              onChange={(newValue) => setValue(newValue)}
              format='dddd, DD/MM/YYYY'
              slots={{
                openPickerIcon: CalendarIcon,
              }}
            />
          </DemoContainer>
        </LocalizationProvider>
      </div>
      <Button className={'calendar-arrow'} onClick={handleRightArrowClick}>
        <img src={arrowRightIcon} alt='Next Day' />
      </Button>
    </div>
  )
}

export default WeeklyCalendar
